<template>
    <div data-test-view="reviews-templates-edit-confirm">
        <l-reviews-edit-templates-header :id="id" :title="$t(`reviews.admin.confirmTitle`)" />

        <p><l-text :text="$t(`reviews.admin.helpSetupCompleteTemplate`)" /></p>
        <hr />

        <l-reviews-edit-confirm-admin-form :id="id" is-template />
    </div>
</template>

<script>
import LText from "@/components/LText";

import LReviewsEditTemplatesHeader from "@/components/LReviewsEditTemplatesHeader";
import LReviewsEditConfirmAdminForm from "@/components/LReviewsEditConfirmAdminForm";

export default {
    components: {
        LText,

        LReviewsEditTemplatesHeader,
        LReviewsEditConfirmAdminForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
};
</script>
